import { Button } from '@lt/components';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import EditIcon from '@lt/components/icons-react/Edit';
import { useTranslation } from '@lt/localization';
import { CLIENT_DATA_ID } from 'src/routes/Checkout/store/constants/tourists';
import Client from '../Client';
import type { PropsFromRedux } from '.';
import { TEST_ID_CLIENT_DATA, TEST_ID_CLIENT_DATA_BUTTON } from './constants';

interface IProps extends PropsFromRedux {
  isHotelOnly: boolean;
}

export const ClientDataBanner = ({
  name,
  surname,
  phone,
  email,
  isMobile,
  isLoggedIn,
  unconfirmedPhone,
  isHotelOnly,
}: IProps) => {
  const { t } = useTranslation();
  const clientDataTitle = t('checkout.client');
  const [showClientDataChange, setShowClientDataChange] = useState(false);

  return (
    <>
      <SubTitle $isHotelOnly={isHotelOnly}>{clientDataTitle}</SubTitle>

      {showClientDataChange || !isLoggedIn || unconfirmedPhone ? (
        <Client openShortForm={() => setShowClientDataChange(false)} />
      ) : (
        <StyledClientDataBanner
          isMobile={isMobile}
          data-testid={TEST_ID_CLIENT_DATA}
          id={CLIENT_DATA_ID}
        >
          <Section>
            <Title>
              {t('checkout.registrationForm.name.header')}{' '}
              {t('checkout.registrationForm.surname.header')}
            </Title>
            <ClientDataItem>{`${name} ${surname}`}</ClientDataItem>
          </Section>
          <Section>
            <Title>{t('checkout.registrationForm.phone.header')}</Title>
            <ClientDataItem>{phone}</ClientDataItem>
          </Section>
          <Section>
            {/*  eslint-disable-next-line i18next/no-literal-string */}
            <Title>Email</Title>
            <ClientDataItem>{email}</ClientDataItem>
          </Section>
          <ChangeDataButton
            onClick={() => setShowClientDataChange(true)}
            data-testid={TEST_ID_CLIENT_DATA_BUTTON}
          >
            <StyledEditIcon />
            {t('checkout.registrationForm.changeDataButton')}
          </ChangeDataButton>
        </StyledClientDataBanner>
      )}
    </>
  );
};

const SubTitle = styled.div<{ $isHotelOnly: boolean }>`
  padding-left: 8px;
  color: #17181a;
  font-weight: 700;
  margin-bottom: 16px;
  font-size: 24px;
  ${({ $isHotelOnly }) =>
    $isHotelOnly &&
    css`
      margin-top: 22px;
    `}
`;

const Title = styled.div`
  color: #919499;
  font-size: 12px;
  margin-bottom: 4px;
`;

const Section = styled.div``;

const StyledClientDataBanner = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) =>
    isMobile
      ? css`
          ${Section} {
            display: flex;
            margin-bottom: 8px;
          }
          ${Title} {
            width: 120px;
          }
          ${SubTitle} {
            font-size: 18px;
          }
        `
      : css`
          display: flex;
          justify-content: space-between;
          ${SubTitle} {
            font-size: 22px;
          }
        `}
  background: #fff;
  padding: 16px;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(210, 208, 197, 0.9),
    0px 10px 15px rgba(216, 214, 204, 0.9);
  width: 100%;
`;

const ChangeDataButton = styled(Button).attrs({ size: 'tiny' })`
  background: #fff;
  font-size: 13px;
  width: 100px;
  height: 40px;
  display: flex;
  align-items: center;
`;

const StyledEditIcon = styled(EditIcon)`
  width: 13px;
  height: 13px;
  path {
    stroke: #007aff;
  }
  margin-right: 4px;
`;

const ClientDataItem = styled.div`
  font-size: 14px;
  color: #4d4d4d;
`;

export default ClientDataBanner;
